import React from 'react';
import { UserAvatar } from '@/components/Avatar';
import { Row, Stack } from '@/ui/primatives';
import * as Tooltip from '@/ui/Tooltip';
import { IEntityUser } from '@/types';
import { IRemoteWorkspace } from '@/lib/workspaces/workspaceApi';
import { formatDateTime } from '@/lib/dateTime';
import { IMarimoSandbox } from '@/lib/marimoSandboxesApi';

export const UserToolTipContent: React.FC<{ user: IEntityUser; notebook: IMarimoSandbox }> = ({ user, notebook }) => {
  return (
    <Stack gap={10}>
      <span>
        <UserAvatar user={user} size={32} />
      </span>
      <Stack gap={10}>
        <Row gap={5} alignItems="center" style={{ whiteSpace: 'nowrap' }}>
          <strong>{user.username}</strong>
          {user.name && <span>({user.name})</span>}
        </Row>
        <small className="dim">Created: {formatDateTime(notebook.inserted_at)}</small>
      </Stack>
    </Stack>
  );
};
const UserTooltip: React.FC<{ user: IEntityUser; notebook: IMarimoSandbox }> = ({ user, notebook }) => {
  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
        <div>
          <UserAvatar user={user} size={16} />
        </div>
      </Tooltip.Trigger>
      <Tooltip.Content style={{ backgroundColor: 'white' }}>
        <UserToolTipContent user={user} notebook={notebook} />
      </Tooltip.Content>
    </Tooltip.Root>
  );
};

export default UserTooltip;
